import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant"];
import React from "react";
import { Link } from "../../../../Link";
import { jsx as _jsx } from "react/jsx-runtime";
function LinkCell(_ref) {
  var variant = _ref.variant,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Link, _extends({
    variant: "inherit"
  }, restProps));
}
LinkCell.displayName = "LinkCell";
export default LinkCell;